
export default {
  name: 'NewsAndGuides',

  async asyncData({ $prismic, error }) {
    try {
      const { data: selectedArticles } = await $prismic.api.getByID(
        'YUs2mRAAACIA3XAd',
        {
          fetchLinks: [
            'news_and_guides.category',
            'categories.category',
            'news_and_guides.featured_image',
            'news_and_guides.title',
            'news_and_guides.subtitle',
          ],
        }
      )

      const { results: articles, total_results_size: totalResultsSize } =
        await $prismic.api.query('[at(document.type, "news_and_guides")]', {
          fetchLinks: 'categories.category',
          orderings:
            '[my.news_and_guides.publish_date_override desc, document.last_publication_date desc]',
          pageSize: 9,
        })

      const { results: interviews } = await $prismic.api.query(
        [
          '[at(document.type, "news_and_guides")]',
          '[at(my.news_and_guides.category, "YUxIEBAAACQA4oKw")]',
        ],
        {
          fetchLinks: 'categories.category',
          orderings:
            '[my.news_and_guides.publish_date_override desc, document.last_publication_date desc]',
          pageSize: 4,
        }
      )

      const { results: categories } = await $prismic.api.query(
        '[at(document.type, "categories")]'
      )
      return {
        categories,
        articles,
        interviews,
        totalResultsSize,
        popularGuides: selectedArticles.popular_guides,
        featuredArticle: selectedArticles.home,
      }
    } catch (e) {
      error({ statusCode: 404, message: 'Articles could not be loaded' })
    }
  },

  data() {
    return {
      showFilters: false,
      categories: [],
      articles: [],
      interviews: [],
      popularGuides: [],
      featuredArticle: {},
      totalResultsSize: 0,
    }
  },

  head() {
    return {
      title: 'News & guides on executive and board hiring | Nurole',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Read our news articles and expert guides covering successful executive hiring for all sectors. Discover stories from thought leaders.',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            'Read our news articles and expert guides covering successful executive hiring for all sectors. Discover stories from thought leaders.',
        },
      ],
    }
  },
  computed: {
    refLabel() {
      return 'interview'
    },
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters
    },

    async loadMore() {
      const query = ['[at(document.type, "news_and_guides")]']

      const { results } = await this.$prismic.api.query(query, {
        fetchLinks: 'categories.category',
        orderings:
          '[my.news_and_guides.publish_date_override desc, document.last_publication_date desc]',
        pageSize: 9,
        page: this.articles.length / 9 + 1,
      })

      this.articles = this.articles.concat(results)
    },
  },
}
